import { render, staticRenderFns } from "./MbExerciseStats.vue?vue&type=template&id=16d15598&"
import script from "./MbExerciseStats.vue?vue&type=script&lang=js&"
export * from "./MbExerciseStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports